import { REACT_APP_OKTA_CLIENT_ID, REACT_APP_OKTA_ISSUER } from "./terraformConfig";  

const OKTA_TESTING_DISABLEHTTPSCHECK = import.meta.env.NODE_ENV === "development" ? import.meta.env.OKTA_TESTING_DISABLEHTTPSCHECK : false;
const REDIRECT_URI = `${globalThis.location.origin}/login/callback`

export const oktaConfig = {
  clientId: REACT_APP_OKTA_CLIENT_ID,
  issuer: REACT_APP_OKTA_ISSUER,
  redirectUri: REDIRECT_URI,
  scopes: ['openid', 'profile', 'email'],
  pkce: true,
  disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
  audience: 'Policy_Compliance_Viewer',
  tokenManager: {
    autoRenew: true,
    autoRemove: true
  }
};
